/* eslint-disable
    no-restricted-globals,
    one-var
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import _ from 'underscore';

import {assert} from 'Asserts';
import {DNA_COMPLEMENT_TABLE} from 'biojs/BioConstants';
import * as util from 'biojs/Util';
import * as CRISPRConstants from 'constants/CRISPRConstants';
import {CRISPRAnalysis, CRISPRGuide, CRISPRRegion, NUCLEASE_TYPE, PAM} from 'constants/CRISPRConstants';
import {StrandOfDoubleStranded} from 'constants/MolbioConstants';
import SearchDNAData from 'molbio/biological-search/SearchDNAData';
import * as sequtil from 'molbio/SeqUtil';
import * as logging from 'util/Logging';

declare class Sequence extends Backbone.Model {
  length: () => number;
  circular: () => boolean;
  bases: () => string;
}

function guideStart(guide: CRISPRGuide, sequenceLength: number, _isLeftPam?: boolean): number {
  // Keep in sync with benchling/molbio/crispr/util.py:guide_start
  if (_isLeftPam) {
    if (guide.strand === 1) {
      return sequtil.mod(guide.position - CRISPRConstants.LEFT_PAM_TO_CUT_DISTANCE, sequenceLength);
    } else {
      return sequtil.mod(
        guide.position + CRISPRConstants.LEFT_PAM_TO_CUT_DISTANCE - guide.bases.length,
        sequenceLength
      );
    }
  } else if (guide.strand === 1) {
    return sequtil.mod(
      guide.position + CRISPRConstants.PAM_TO_CUT_DISTANCE - guide.bases.length,
      sequenceLength
    );
  } else {
    return sequtil.mod(guide.position - CRISPRConstants.PAM_TO_CUT_DISTANCE, sequenceLength);
  }
}

function guideEnd(guide: CRISPRGuide, sequenceLength: number, _isLeftPam?: boolean): number {
  // Keep in sync with benchling/molbio/crispr/util.py:guide_end
  if (_isLeftPam) {
    if (guide.strand === 1) {
      return sequtil.mod(
        guide.position - CRISPRConstants.LEFT_PAM_TO_CUT_DISTANCE + guide.bases.length,
        sequenceLength
      );
    } else {
      return sequtil.mod(guide.position + CRISPRConstants.LEFT_PAM_TO_CUT_DISTANCE, sequenceLength);
    }
  } else if (guide.strand === 1) {
    return sequtil.mod(guide.position + CRISPRConstants.PAM_TO_CUT_DISTANCE, sequenceLength);
  } else {
    return sequtil.mod(
      guide.position - CRISPRConstants.PAM_TO_CUT_DISTANCE + guide.bases.length,
      sequenceLength
    );
  }
}

function findGuidesInRange(
  sequence: Sequence,
  search: SearchDNAData,
  analysis: CRISPRAnalysis,
  start: number,
  end: number,
  strand: StrandOfDoubleStranded | null
): Array<CRISPRGuide> {
  // Keep in sync with benchling/molbio/crispr/util.py:find_guides_in_range
  const {guideLength, pam, isLeftPam: _isLeftPam} = analysis;
  const sequenceBases = sequence.bases();
  const sequenceCircular = sequence.circular();
  const sequenceLength = sequenceBases.length;

  search.set({
    region: (() => {
      switch (strand) {
        case 1:
          return 'fwd';
        case -1:
          return 'rev';
        default:
          return 'all';
      }
    })(),
  });

  const guides: Array<CRISPRGuide> = [];

  const tempGuide = Array(guideLength + 1).join('N');
  const seq = _isLeftPam ? pam + tempGuide : tempGuide + pam;
  search.doSearch(seq, {start, end}, {dedup: true});
  search.get('results').each((result) => {
    let allBases, cut;
    start = result.get('start');
    end = result.get('end');
    strand = result.get('strand');
    if (strand === 1) {
      allBases = util.slice(sequenceBases, start, end, sequenceCircular);
      cut = _isLeftPam
        ? sequtil.mod(start + pam.length + CRISPRConstants.LEFT_PAM_TO_CUT_DISTANCE, sequenceLength)
        : sequtil.mod(end - pam.length - CRISPRConstants.PAM_TO_CUT_DISTANCE, sequenceLength);
    } else {
      allBases = util.revcomp(util.slice(sequenceBases, start, end, sequenceCircular), DNA_COMPLEMENT_TABLE);
      cut = _isLeftPam
        ? sequtil.mod(end - pam.length - CRISPRConstants.LEFT_PAM_TO_CUT_DISTANCE, sequenceLength)
        : sequtil.mod(start + pam.length + CRISPRConstants.PAM_TO_CUT_DISTANCE, sequenceLength);
    }
    // Ignore guides that have degenerate bases
    if (util.isDegenerate(allBases)) {
      return;
    }
    const basesLength = allBases.length - pam.length;
    const actualPam = _isLeftPam ? allBases.substring(0, pam.length) : allBases.substring(basesLength);
    const bases = _isLeftPam ? allBases.substring(pam.length) : allBases.substring(0, basesLength);
    guides.push({
      bases,
      pam: actualPam,
      position: cut,
      strand,
      offTargetScore: null,
      sites: null,
    });
  });
  return guides;
}

function findGuides(
  sequence: Sequence,
  search: SearchDNAData,
  analysis: CRISPRAnalysis,
  start: number,
  end: number
): Array<CRISPRGuide> {
  assert(!isNaN(start) && !isNaN(end), 'Must provide both start and end');
  return findGuidesInRange(sequence, search, analysis, start, end, null);
}

function pairOffset(fwdStart: number, revEnd: number, sequenceLength: number, circular: boolean): number {
  // Keep in sync with benchling/molbio/crispr/util.py:pair_offset
  // Calculates the offset between the start of the forward guide and the end of the reverse guide
  if (circular == null) {
    circular = false;
  }
  if (!circular || Math.abs(fwdStart - revEnd) <= sequenceLength / 2) {
    return fwdStart - revEnd;
  }
  if (fwdStart > revEnd) {
    return fwdStart - revEnd - sequenceLength;
  }
  return sequenceLength + fwdStart - revEnd;
}

function filterGuides(
  sequence: Sequence, // Figure out if outer or inner sequence model
  analysis: CRISPRAnalysis,
  guides: Array<CRISPRGuide>,
  {
    skipTypeFilter,
    skipCutsOutsideRegions,
  }: {
    skipTypeFilter: boolean;
    skipCutsOutsideRegions: boolean;
  } = {skipTypeFilter: false, skipCutsOutsideRegions: false}
): Array<CRISPRGuide> {
  // Keep in sync with benchling/molbio/crispr/util.py:filter_guides
  const sequenceLength = sequence.length();

  if (skipCutsOutsideRegions) {
    guides = guides.filter((guide) => {
      const {regions} = analysis;
      const start = guideStart(guide, sequenceLength, analysis.isLeftPam);
      const end = guideEnd(guide, sequenceLength, analysis.isLeftPam);
      return regions.some((region) => sequtil.isRangeWithin(start, end, region.start, region.end));
    });
  }

  guides = guides.filter((guide) => {
    const {bases} = guide;
    const counts = util.count(bases, util.NucleotideType.DNA);
    // eslint-disable-next-line no-restricted-syntax
    for (const key of Array.from(_.keys(counts))) {
      // @ts-expect-error
      counts[key] = (100 * counts[key]) / bases.length;
    }
    const a = analysis.aMin <= counts.A && counts.A <= analysis.aMax;
    const t = analysis.tMin <= counts.T && counts.T <= analysis.tMax;
    const c = analysis.cMin <= counts.C && counts.C <= analysis.cMax;
    const g = analysis.gMin <= counts.G && counts.G <= analysis.gMax;
    return a && t && c && g;
  });

  if (analysis.designType === CRISPRConstants.DESIGN_TYPE.BASE_EDIT) {
    guides = guides.filter((guide) => {
      for (const base of Array.from(guide.bases.slice(0, 8))) {
        if (base.toUpperCase() === CRISPRConstants.FORWARD_STRAND_EDITABLE_BASE) {
          return true;
        }
      }
      return false;
    });
  }

  if (analysis.designType === CRISPRConstants.DESIGN_TYPE.PAIRED && !skipTypeFilter) {
    const min = analysis.pairOffsetMin;
    const max = analysis.pairOffsetMax;

    const forward = guides.filter((guide) => guide.strand === 1);
    const reverse = guides.filter((guide) => guide.strand === -1);

    guides = [];
    for (const g1 of Array.from(reverse)) {
      const g1End = guideEnd(g1, sequenceLength, analysis.isLeftPam);
      // If the sequence is linear, a reverse guide ending at the end (wraps to 0)
      // should not be paired with any forward guides.
      if (g1End === 0 && !sequence.circular()) {
        continue;
      }
      for (const g2 of Array.from(forward)) {
        const g2Start = guideStart(g2, sequenceLength, analysis.isLeftPam);
        const offset = pairOffset(g2Start, g1End, sequence.length(), sequence.circular());
        if (min <= offset && offset <= max) {
          guides.push(g2);
          guides.push(g1);
        }
      }
    }
  }

  return guides;
}

function canRegenerateRegion(region: CRISPRRegion, seqLength: number): boolean {
  return 0 <= region.start && region.start < seqLength && 0 < region.end && region.end < seqLength;
}

function isLeftPam(pam: PAM | string): boolean {
  // eslint-disable-next-line benchlint/no-in-operator
  return pam in PAM && CRISPRConstants.PAM_INFO_BY_PAM[pam as PAM].isLeftPam;
}

function isCas9Pam(pam: PAM | string): boolean {
  // eslint-disable-next-line benchlint/no-in-operator
  return pam in PAM && CRISPRConstants.PAM_INFO_BY_PAM[pam as PAM].nucleaseType === NUCLEASE_TYPE.CAS9;
}

function getNucleaseType(pam: PAM | string, leftPam: boolean): NUCLEASE_TYPE {
  // eslint-disable-next-line benchlint/no-in-operator
  if (pam in PAM) {
    return CRISPRConstants.PAM_INFO_BY_PAM[pam as PAM].nucleaseType;
  }
  // Cpf1 is the only known nuclease on the 5' side.
  return leftPam ? NUCLEASE_TYPE.CPF1 : NUCLEASE_TYPE.CAS9;
}

function renderStrand(guide: CRISPRGuide): string | null {
  if (guide.strand === 1) {
    return '+';
  }
  if (guide.strand === -1) {
    return '-';
  }
  logging.error('Unexpected strand value in guide.');
  return null;
}

function getForwardStrandBases(guide: CRISPRGuide): string {
  if (guide.strand === 1) {
    return guide.bases;
  }
  return util.revcomp(guide.bases, DNA_COMPLEMENT_TABLE);
}

export {
  canRegenerateRegion,
  filterGuides,
  findGuidesInRange,
  findGuides,
  getForwardStrandBases,
  getNucleaseType,
  guideStart,
  guideEnd,
  isLeftPam,
  isCas9Pam,
  renderStrand,
  pairOffset,
};
